<template>
  <div class="container word-cloud-dialog">
    <div
      class="backdrop"
      v-show="visible"
      :style="{width: Window_Size.width + 'px',height: Window_Size.height + 'px'}"
      @click.stop="dialogOnClick()"
      @mousedown.stop
    ></div>

    <transition name="el-fade-in">
      <div
        class="main"
        v-show="visible"
        :style="{width: dialogSize.width + 'px',height: dialogSize.height + 'px', left: dialogSize.left + 'px', top: dialogSize.top + 'px'}"
        @click="dialogOnClick()"
      >
        <div class="header"><span>文字云</span></div>
        <div class="content">
          <div class="controls">
            <div>
              <folder
                v-for="(item, i) in folders" :key="i"
                :title="item.title"
                :index='i'
                @toggleFolded="onFolderToggle"
                ref="folder"
              >
                <div v-if="i === 0">
                  <text-control ref="textControl"></text-control>
                </div>
                <div v-if="i === 1">
                  <shape-control v-if="visible" ref="shapeControl"></shape-control>
                </div>
                <div v-if="i === 2">
                  <style-control ref="styleControl"></style-control>
                </div>
              </folder>
            </div>
          </div>
          <div class="viewer">
            <viewer ref="viewer"></viewer>
          </div>
        </div>
        <div class="guide-mask" :class="{ghost: !showGuide}">
          <div class="btn" @click="endGuide()">开始使用</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import viewer from './viewer'
import folder from './folder'
import textControl from './textControl'
import shapeControl from './shapeControl'
import styleControl from './styleControl'

export default {
  components: {
    viewer,
    folder,
    textControl,
    shapeControl,
    styleControl
  },
  props: {
    visible: Boolean,
  },
  data () {
    return {
      showGuide: true,
      folders: [
        {title: '文本'},
        {title: '形状'},
        {title: '样式'},
      ],
    }
  },
  computed: {
    ...mapGetters([
      'Window_Size',
      'TOOL',
    ]),
    dialogSize () {
      let width = Math.min(1280, this.Window_Size.width - 88);
      let height = Math.min(710, this.Window_Size.height - 50);
      let left = (this.Window_Size.width - width) / 2;
      let top = (this.Window_Size.height - height) / 2;
      return {
        width,
        height,
        left,
        top
      }
    }
  },
  watch: {
    visible (val) {
      this.$store.commit('toggle_isPreventDefault', !val);

      if (val) {
        let folders = this.$refs.folder;
        let filtered = folders.filter(item => item.folded);
        if (filtered.length === folders.length) {
          folders[0].toggleFolded();
        }
      }
    }
  },
  created () {
    const vm = this;
    this.$bus.on('wordCloud.submit', () => {
      let textControl = vm.getControl('text');
      let content = textControl.list;
      content = content.map(item => {
        return {
          word: item.text.value,
          freq: +item.size.value,
          color: item.color.value,
          font: textControl.currentFont.value || '',
        }
      })
      // content = JSON.stringify(content);

      let shapeControl = vm.getControl('shape');
      let shape = shapeControl.getActiveShape();

      let styleControl = vm.getControl('style');
      let style = styleControl.getControls();
      style.font = textControl.currentFont.value;

      this.$refs.viewer.submit(content, shape, style);
    });

    this.$bus.on('wordCloud.addPicToEditorDone', () => {
      // let textControl = vm.getControl('text');
      // let shapeControl = vm.getControl('shape');
      // let styleControl = vm.getControl('style');
      // textControl.doReset();
      // shapeControl.reset();
      // styleControl.reset();
      this.onFolderToggle(false, 0);
    });
  },
  mounted () {

  },
  methods: {
    close () {
      this.$store.commit('save_TopnavMsg', {
        isShowWordCloudDialog: false
      });
    },

    onFolderToggle (folded, index) {
      if (folded) {
        return;
      }
      let list = this.$refs.folder;
      list.forEach((item, i) => {
        if (index !== i) {
          item.folded = true;
        }
      });

      let msgs = [
        'word_cloud,click_text，文字云_点击_文本',
        'word_cloud,click_shape，文字云_点击_形状',
        'word_cloud,click_shape，文字云_点击_样式'
      ];
      this.$analysis(msgs[index])
    },

    getControl (name) {
      return this.$refs[`${name}Control`][0];
    },

    dialogOnClick () {
      this.$bus.emit('FeaturesPop_close_vue', {
        type: 3,
      });
      this.$bus.emit('wordCloud.hidePopups');
    },

    endGuide () {
      this.showGuide = false

    },

    handleGuide () {
      let stored = this.$util.localStorage.get('UserGuideShown')
      if (stored) {
        this.showGuide = false;
      }
      this.$util.localStorage.set('UserGuideShown', true);
    }
  }
}
</script>

<style lang="scss" scoped>
.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(#39393C, .8);
}
.main {
  position: absolute;
  top: 25px;
  left: 44px;
  background-color: #fff;
  box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 8px;
}
.header {
  height: 42px;
  line-height: 42px;
  background-color: #d9ddea;
  padding-left: 1em;
	border-radius: 4px 4px 0 0;
  margin-bottom: 6px;
  text-align: left;
}

.content {
  display: flex;
}
.controls {
  flex-grow: 0;
  width: 648px;
	height: 656px;
  background-color: #fff;

  & > div {
    margin: auto;
    width: 620px;
  }
}
.viewer {
  flex-grow: 0;
  width: 648px;
	height: 656px;
}

.guide-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(../../../../static/img/word-cloud-guide.png);
  overflow: hidden;
  &.ghost {
    width: 0;
    height: 0;
  }

  & > .btn {
    position: absolute;
    right: 54px;
    bottom: 48px;
    width: 120px;
    height: 48px;
    line-height: 48px;
    color: #fff;
    border-radius: 4px;
    background-color: #5778fb;

    &:hover {
      background-color: #7993fc;
    }
  }
}
</style>

<style lang="scss">
.container .btn {
  cursor: pointer;
}
.container .pointer {
  cursor: pointer;
}
.container.word-cloud-dialog {
  color: #474261;
}
.container.word-cloud-dialog * {
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/emodal/wordCloud/wordCloudDialog.vue